<div class="flex flex-col gap-2 px-4 overflow-hidden">
  <div class="flex items-center">
    <div class="flex-auto block font-medium text-sm select-none">Tags</div>
  </div>

  @if (canReadTags()) {
    <app-tag-filter
      [tags]="allTags()"
      [selectedTagIds]="assignedTagIds()"
      (selectedTagIdsChange)="handleTagSelectionChange($event)"
      [disabled]="disabled()"
    />
  } @else if (!disabled()) {
    <div class="text-xs text-gray-500 px-1">
      Om tags toe te voegen heb je het recht "{{ tagReadLabel }}" nodig.
    </div>
  }

  @if (assignedTags().length === 0) {
    <div class="text-xs text-gray-400 px-1">Geen tags toegewezen</div>
  }

  <div class="flex flex-wrap gap-1 mt-2">
    @for (tag of activeAssignedTags(); track tag.id) {
      <div
        class="inline-flex items-center gap-1 bg-gray-300 text-gray-800 py-1 px-2 rounded-full text-xs font-medium max-w-full"
        [matTooltip]="tag.label"
        matTooltipPosition="above"
      >
        <span class="truncate min-w-0">{{ tag.label }}</span>
        @if (!disabled()) {
          <button mat-icon-button class="shrink-0 p-0! inline-flex! items-center! justify-center! -mr-1 size-5! hover:text-gray-800!" (click)="removeTag(tag)">
            <mat-icon class="text-base! size-4! leading-none! font-medium!">cancel</mat-icon>
          </button>
        }
      </div>
    }

    @for (tag of inactiveAssignedTags(); track tag.id) {
      <div
        class="inline-flex items-center gap-1 bg-gray-200 text-gray-400 py-1 px-2 rounded-full text-xs font-medium max-w-full"
        [matTooltip]="tag.label + ' — Deze tag is inactief en kan niet worden gewijzigd'"
        matTooltipPosition="above"
      >
        <span class="truncate min-w-0">{{ tag.label }}</span>
      </div>
    }
  </div>
</div>
